var keywords = module.exports = {
    style: [
        'italic',
        'oblique'
    ],
    variant: [
        'small-caps'
    ],
    weight: [
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'bold',
        'lighter',
        'bolder'
    ],
    stretch: [
        'ultra-condensed',
        'extra-condensed',
        'condensed',
        'semi-condensed',
        'semi-expanded',
        'expanded',
        'extra-expanded',
        'ultra-expanded'
    ],
    size: [
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
        'larger',
        'smaller'
    ]
};



//////////////////
// WEBPACK FOOTER
// ./~/postcss-minify-font-values/lib/keywords.js
// module id = 3453
// module chunks = 0